// Initialize IndexedDB
const dbName = 'SongDatabase';
const storeName = 'songs';
const version = 1;

const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, version);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName);
      }
    };
  });
};

export const saveSong = async (index, song) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const request = store.put(song, index);

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);

    tx.oncomplete = () => db.close();
  });
};

export const loadSongs = async () => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readonly');
    const store = tx.objectStore(storeName);
    const songs = Array(10).fill(null);
    let completed = 0;

    for (let i = 0; i < 10; i++) {
      const request = store.get(i);

      request.onsuccess = () => {
        if (request.result !== undefined) {
          songs[i] = request.result;
        }
        completed++;
        if (completed === 10) {
          resolve(songs);
          db.close();
        }
      };

      request.onerror = () => reject(request.error);
    }

    tx.oncomplete = () => db.close();
  });
};

export const removeSongFromDB = async (index) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const request = store.delete(index);

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);

    tx.oncomplete = () => db.close();
  });
};
